// ©2024 Austin App House. All rights reserved.
import React, { useState } from 'react';
import { MDBTable } from 'mdbreact';
import Headers from './headers';
import Body from './body';
import Footer from './footer';

const Tablet = ({
  className,
  columns,
  handlerSort = () => {},
  sortBy,
  rows,
  ActionElement,
  enableActionsCol,
  actionsColLabel,
  placeholder,
  enablePagination,
  entriesOptions = [5, 20, 25],
  entries,
}) => {
  const [pageNumber, setPageNumber] = useState(0);
  const [perPage, setPerPage] = useState(entries || 5);

  return (
    <div className={className ? 'subpage-table-inner' : ''}>
      <table className={className || 'custom_table'}>
        <Headers
          columns={columns}
          handlerSort={handlerSort}
          enableActionsCol={enableActionsCol}
          actionsColLabel={actionsColLabel}
          sortBy={sortBy}
        />
        <Body
          rows={rows}
          columns={columns}
          ActionElement={ActionElement}
          enableActionsCol={enableActionsCol}
          placeholder={placeholder}
          enablePagination={enablePagination}
          perPage={perPage}
          pageNumber={pageNumber}
        />
      </table>
      <Footer
        enablePagination={enablePagination}
        rowsCount={rows.length}
        entriesOptions={entriesOptions}
        perPage={perPage}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        setPerPage={setPerPage}
      />
    </div>
  );
};

export default Tablet;
